import _ from 'lodash';
import {logFailure} from "./analytics";

export const saveRoof = (data, callback) => {
  // Swap if ever needed
  const storage = sessionStorage;

  if (_.isEmpty(data)) {
    return;
  }

  const roofId = storage.getItem('roofId');
  const roofData = storage.getItem('roofData');

  if (roofId && _.eq(data, roofData)) {
    return callback(roofId);
  }

  fetch(MDMS_URL + '/api/v1/app_data/byr',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then((result) => {
      if(result.ok) {
        return result.json();
      }
      throw "Couldn't save Project";
    })
    .then((result) => {
      callback(result.uuid)
    })
    .catch(() => {
      logFailure('BYR Project Save Failed');
    })
}

export const loadRoof = (id, callback) => {
  return fetch(MDMS_URL + '/api/v1/app_data/byr/' + id, { cors: 'cors' })
    .then((result) => {
      result.json().then((data) => callback(data))
    })
}

export const saveCustomization = (slug, configuration, userToken) => (
  fetch(`${MDMS_URL}/api/v1/app_data/byr_configuration?key=${slug || ''}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${userToken}` },
    body: JSON.stringify(configuration),
  }).then(response => response.json()));
